
import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { getNews, getBaseInfo } from '../api';
import qs from 'qs';

Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class Rule extends Vue {
  list: any[] = [];
  loading = false;
  finished = false;
  page = 1;
  baseInfo: any = {};
  // async created() {
  //   const unionId = window.localStorage.getItem('unionid');
  //   const token = window.gettoken();
  //   if (!isWeiXin() && !window.udid) {
  //     Toast('请在微信或者上游APP打开');
  //   } else if (!unionId && isWeiXin()) {
  //     this.WechatLogin();
  //   } else if (!token && window.udid) {
  //     this.AppLogin();
  //   }
  // }
  async mounted() {
    const ret111 = await getBaseInfo();
    this.baseInfo = ret111.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  onLoad() {
    getNews(this.page, '9915').then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.data.data.length === 0 || res.data.data[0].list.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data.data[0].list];
    }
    this.loading = false;
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
}
